import NodeController05Abi from "@abi/NodeController05";
import type { Address } from "viem";
import { useReadContract } from "wagmi";

// not assigning account to type string, error = Type 'string' is not assignable to type '`0x${string}`'
export const useERC721Balance = (
	account: Address,
	contractAddress: Address,
) => {
	const { data } = useReadContract({
		abi: NodeController05Abi,
		address: contractAddress,
		args: [account],
		functionName: "balanceOf",
	});
	return data ? Number(data?.toString()) : 0;
};
